import { useMutation, useQueryClient } from '@tanstack/react-query';

import { authApi, type SignupRequest } from '@/api/routes/public/auth.api';

export const useSignup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SignupRequest) => authApi.signup(data),
    onSuccess: () => {
      queryClient.clear();
    },
  });
};
